import * as PropTypes from "prop-types";
import React, {useEffect, useState, useContext} from "react";
import {imageLocations} from "../image/ImageLocations";
import SliderPanel from "./SliderPanel";
import {BannerImage} from "../image/BannerImage";
import {useTranslation} from "react-i18next";
import {Row, Typography, Alert} from "antd";
import './Panels.css';
import VehicleCard from "./VehicleCard";
import {getSessionData, getMyVehicleTitleKey} from "../../utility/global-util";
import { SyncOutlined } from '@ant-design/icons';
import GlobalContext from "../../GlobalContext";

const { Title } = Typography;


const MyVehiclePanel = ({contracts, loading, pageLoading, onChange, readOnly, customTitle = null, setRefreshPage}) => {

    const { t } = useTranslation();
    const globalData = useContext(GlobalContext);

    // Contract/slide info
    const contractInfo = [];
    let slideNo = 0;

    // Handle no allocated contracts
    const [dummyMode, setDummyMode] = useState(false);
    const allocContracts = getSessionData("driverHasAllocContracts"); //comes back as string
    useEffect(() => {
        setDummyMode(allocContracts ? allocContracts === 'false': false);
    }, [allocContracts, setDummyMode]);

    const driverQuotes = getSessionData("driverQuotes");
    const hasDriverQuotes = driverQuotes && driverQuotes.length > 0;

    // My vehicles slider and Banner
    return (
      <div>
          <div className="my-vehicle-slider-panel">
              { dummyMode
                ? <div style={{ marginBottom: '20px' }}>
                      <Row className="dp-vehicle-info">
                          <Title level={3}>{customTitle || t(getMyVehicleTitleKey())}</Title>
                      </Row>
                      <Row align="middle" justify="center" style={{ margin: '5px' }}>
                        {
                            !hasDriverQuotes
                            ?
                            <Alert message={t('message.no_vehicles_found')}
                                 description={t('message.not_allocated_vehicle')}
                                 type="warning"
                                 showIcon />                            
                            :
                            <></>
                        }
                          
                      </Row>
                  </div>
                : 
                <div>
                  <SliderPanel loading={loading} readOnly={readOnly} pageLoading={pageLoading} onSlideChange={(child) => {onChange(child.props.contract)}} contractInfo={contractInfo}>
                      {contracts.map(contract => {
                          contractInfo.push({ slideNo: slideNo++, contractNo: contract?.contractNo });
                          return (<VehicleCard key={contract.contractNo} loading={false} pageLoading={pageLoading} contract={contract} customTitle={customTitle}/>);
                      })}
                  </SliderPanel> 
                  {
                    globalData && globalData.currentRouteId && globalData.currentRouteId === 'home'
                    ? <div className="dp-home-refresh-button">
                        <SyncOutlined
                            style={{fontSize: '25px', cursor: pageLoading ? 'default' : 'pointer'}}
                            spin={pageLoading}
                            onClick={() => {
                                if (!pageLoading) {
                                    setRefreshPage(true);
                                }
                            }}
                        />
                      </div>
                    : <></>
                  }
                             
                </div>
              }
          </div>
          <div className="my-vehicle-top-banner">
            <BannerImage imageSrc={imageLocations.NIGHT_BANNER_IMAGE} />
          </div>
        </div>
    )
}

// Validate prop type parameters.
MyVehiclePanel.propTypes = {
    contracts: PropTypes.array,
    loading: PropTypes.bool,
    onChange: PropTypes.func,
    readOnly: PropTypes.bool
};

export default MyVehiclePanel;